<mat-dialog-content>
    <p rtlDiv style="color: red;">{{ 'SITE_MANAGMENT.EXIT_INSTALLATION' | translate }}</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="actions" rtlDiv>
      <button mat-button cdkFocusInitial mat-dialog-close>{{ 'NEW_WORKPLAN.CANCEL' | translate }}</button>
      <button mat-button color="warn" [mat-dialog-close]="true" mat-dialog-close>{{ 'SITE_MANAGMENT.OK' | translate }}</button>
    </div>
  </mat-dialog-actions>